<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { useGameStore } from '@/stores/game';

const game = useGameStore();
const route = useRoute();
const router = useRouter();

const isAuth = computed(() => game.isAuthenticated);

function logout() {
  game.logout();
  router.push('/login');
}
</script>

<template>
  <nav class="navbar navbar-expand-lg navbar-dark border-bottom" style="border-color: #00ff00 !important; background: #050505;">
    <div class="container-fluid">
      <RouterLink class="navbar-brand glow-text-strong" to="/">
        <span class="cursor-blink">&gt;_</span> NETRUNNER
      </RouterLink>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navMain"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="navMain" class="collapse navbar-collapse">
        <ul v-if="isAuth" class="navbar-nav me-auto">
          <li class="nav-item">
            <RouterLink to="/dashboard" class="nav-link" :class="{ active: route.path === '/dashboard' }">
              [ DASHBOARD ]
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/market" class="nav-link" :class="{ active: route.path === '/market' }">
              [ BLACK MARKET ]
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/bank" class="nav-link" :class="{ active: route.path === '/bank' }">
              [ BANK ]
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/exchange" class="nav-link" :class="{ active: route.path === '/exchange' }">
              [ EXCHANGE ]
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/combat" class="nav-link" :class="{ active: route.path === '/combat' }">
              [ ATTACK CONSOLE ]
            </RouterLink>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li v-if="isAuth" class="nav-item d-flex align-items-center me-3">
            <span class="text-success small">
              :: {{ game.user?.handle }} ::
            </span>
          </li>
          <li v-if="isAuth" class="nav-item">
            <button class="btn btn-sm btn-outline-primary" @click="logout">[ LOGOUT ]</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
